/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts"/>

declare var irep: IREP.IREP;

namespace IREP {
    "use strict";

    export class UnsubscribeV3 extends Component {

        constructor(id: string) {

            super(id);

            // Save current value of element
            $("#txtEmail input").data('oldVal', $("#txtEmail input").val());

            // Use data val on #Submitbutton to allow click events
            $('#Submitbutton').data('allowed', true);

            // Look for changes in the value
            $("#txtEmail input").bind("propertychange change click keyup input paste", function (event) {

                // If value has changed...
                if ($("#txtEmail input").data('oldVal') != $("#txtEmail input").val()) {

                    // Updated stored value
                    $("#txtEmail input").data('oldVal', $("#txtEmail input").val());

                    // Hide error messages
                    $("#txtEmail input").removeClass("errorBorder");
                    $('#errorText').hide();

                    // Re-allow click on submit
                    $('#Submitbutton').data('allowed', true);
                }
            });

            $("#Submitbutton").on('click', function () {

                // prevent immediate double-clicks
                if (submitted) { return false; }
                var submitted = true;

                // use #Submitbutton's data-allowed to only allow submission if data has changed.
                if ($('#Submitbutton').data('allowed') === true) {

                    $('#Submitbutton').data('allowed', false);

                    // validate email
                    var regexEmail = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;
                    var email = $("#EmailInput");
                    var isValid = true;

                    // indicate blank value as error to the user
                    if (email.val() == "") {
                        $("#errorText").show();
                        $("#txtEmail input").addClass("errorBorder");
                        isValid = false;
                    };

                    // indicate failed regex values as error to user
                    if (email.val().match(regexEmail) == null) {
                        $("#errorText").show();
                        $("#txtEmail input").addClass("errorBorder");
                        isValid = false;
                    };

                    // only act if data is validated
                    if (isValid == true) {
                        // in case this takes more than a blink of an eye, change the button style & disable it.
                        $('.unsubscribe-submit-button').removeClass('button-promotional--uie-green');
                        $('.unsubscribe-submit-button').addClass('button-promotional--ui-gray-light');
                        $('.unsubscribe-submit-button').css({
                            'cursor': 'default',
                            'pointer-events': 'none'
                        });
                    }

                    return isValid;
                }
            });

            //function unsubscribe() {

            //    // in case this takes more than a blink of an eye, change the button style & disable it.
            //    $('.unsubscribe-submit-button').removeClass('button-promotional--uie-green');
            //    $('.unsubscribe-submit-button').addClass('button-promotional--ui-gray-light');
            //    $('.unsubscribe-submit-button').css({
            //        'cursor': 'default',
            //        'pointer-events': 'none'
            //    });

            //    $.ajax({
            //        type: "post",
            //        dataType: "html",
            //        url: irep.options.appUrl + "UnsubscribeEmail/" + $('#EmailInput').val(),
            //        //Serializes all parts of the form including the anti-forgery token. 
            //        //Concatenate the sub-form. Kinda hack-ish. But it works. 
            //        data: $("form").serialize()
            //    }).done((returnedHtml) => {
            //        $('#UnsubscribeUser').html(returnedHtml);
            //    });
            //}
        };
    }
}

